// Rechecked against the official websites on 2026-10-24. See the audit in docs/.
// These stages are deliberately separate; training targets live in bufferStandards.js.
export const standardsVerifiedDate = "2026-10-24";
export const standardsVerifiedLabel = "24 oktober 2026";

export const standardsScope =
  "De functionele fysieke aanstellingskeuring wordt bepaald door het functiecluster van je vacature. De aanvullende Fitheidstest Mariniers, fysieke basiseisen voor KCT-informatiedagen en Kennismakingsdagen Luchtmobiel zijn afzonderlijke testmomenten. Mission Movement is onafhankelijk van Defensie en geeft geen garantie op toelating of selectie.";

export const officialStandards = {
  cluster6: {
    title: "Cluster 6: functionele fysieke aanstellingskeuring",
    sourceUrl:
      "https://werkenbijdefensie.nl/alles-over-je-sollicitatie-aanstellingskeuring",
    sourceLabel: "Defensie: aanstellingskeuring",
    summary:
      "Deze onderdelen horen bij de functionele fysieke aanstellingskeuring voor functiecluster 6. Controleer in je vacature welk cluster van toepassing is. De Fitheidstest Mariniers, KCT-informatiedagen en Kennismakingsdagen Luchtmobiel zijn afzonderlijke testmomenten.",
    requirements: [
      {
        id: "run",
        label: "Onbelast hardlopen",
        minimumValue: 2700,
        minimumLabel: "2700 meter binnen 12 minuten",
        protocol: "De test stopt zodra de vereiste afstand is bereikt.",
      },
      {
        id: "march",
        label: "Progressieve mars",
        minimumLabel:
          "2 km in 24 minuten met 25 kg, daarna 2 km in 24 minuten met 35 kg, daarna 800 meter in 10 minuten met 45 kg",
      },
      {
        id: "carry",
        label: "Progressief tillen en dragen van een munitiekist",
        minimumLabel: "10 herhalingen met 20 kg, 10 met 30 kg en 5 met 40 kg",
        protocol:
          "Per herhaling draag je de kist 25 meter; iedere 25 seconden begint een herhaling. De eerste herhaling per gewicht begint op de grond, de volgende op de tiltafel. Na de laatste herhaling gaat de kist naar de grond, behalve bij 40 kg: die blijft op de tafel. De tafelhoogte volgt het officiële protocol.",
      },
      {
        id: "dig",
        label: "Gesimuleerde graaftest",
        minimumLabel: "120 seconden",
        protocol:
          "Een graafbeweging met een medicine ball, met wisseling van zijde na telkens 30 seconden.",
      },
    ],
    note:
      "Dit is een selectie van onderdelen, geen volledige keuringschecklist. Defensie beschrijft ook taken boven schouderhoogte en een binnenparcours met onder andere houdingen, kruipen, klimmen en springen. Volg voor de volledige uitvoering de officiële bron en je uitnodiging. De testgewichten zijn geen startadvies voor training.",
  },
  mariniers: {
    title: "Korps Mariniers: aanvullende Fitheidstest",
    sourceUrl: "https://werkenbijdefensie.nl/korps-mariniers",
    sourceLabel: "Defensie: Korps Mariniers",
    summary:
      "De Fitheidstest is een aanvullend onderdeel van het sollicitatieproces voor het Korps Mariniers. Deze test staat los van de functiegebonden aanstellingskeuring en de Kennismakingsdagen Mariniers.",
    requirements: [
      { id: "run", label: "Hardlopen", minimumValue: 2700, minimumLabel: "2700 meter in 12 minuten" },
      { id: "pullups", label: "Pull-ups", minimumValue: 4, minimumLabel: "4 in 2 minuten" },
      { id: "pushups", label: "Push-ups", minimumValue: 30, minimumLabel: "30 in 2 minuten" },
      { id: "situps", label: "Sit-ups", minimumValue: 30, minimumLabel: "30 in 2 minuten" },
    ],
    note:
      "Volgens de officiële unitpagina worden deze onderdelen achter elkaar uitgevoerd. Het halen van de Fitheidstest betekent niet dat je ook de overige selectieonderdelen hebt afgerond.",
  },
  kct: {
    title: "KCT: fysieke basiseisen voor informatiedagen",
    sourceUrl: "https://werkenbijdefensie.nl/commando-worden",
    sourceLabel: "Defensie: Commando worden",
    summary:
      "Deze fysieke basiseisen gelden voor de KCT-informatiedagen. Ze zijn niet hetzelfde als de functionele aanstellingskeuring of de eisen van latere selectie- en opleidingsfasen.",
    requirements: [
      { id: "run", label: "Hardlopen", minimumValue: 2800, minimumLabel: "2800 meter in 12 minuten" },
      { id: "pullups", label: "Strikte pull-ups", minimumValue: 6, minimumLabel: "6 zonder tijdslimiet" },
      { id: "pushups", label: "Push-ups", minimumValue: 30, minimumLabel: "30 in 2 minuten" },
      { id: "situps", label: "Sit-ups", minimumValue: 40, minimumLabel: "40 in 2 minuten" },
    ],
    note:
      "Volg de uitvoering die Defensie voorschrijft, waaronder het metronoomprotocol voor push-ups en sit-ups. Deze basiseisen geven geen garantie op toelating of het halen van de opleiding.",
  },
  luchtmobiel: {
    title: "Luchtmobiel: geselecteerde onderdelen Kennismakingsdagen",
    sourceUrl: "https://werkenbijdefensie.nl/kennismakingsdagen-luchtmobiel",
    sourceLabel: "Defensie: Kennismakingsdagen Luchtmobiel",
    summary:
      "De officiële pagina beschrijft deze onderdelen voor de Kennismakingsdagen voor soldaat- en korporaalfuncties bij Luchtmobiel. Dit is een afzonderlijk selectiemoment, geen algemene testlijst voor iedere functie binnen de brigade. Controleer het aanstellingscluster in je actuele vacature.",
    requirements: [
      { id: "run", label: "Hardlopen", minimumValue: 2700, minimumLabel: "2700 meter in 12 minuten" },
      { id: "carry", label: "Munitiekisten tillen en dragen", minimumLabel: "10 keer 20 kg, 10 keer 30 kg en 5 keer 40 kg over 25 meter" },
      { id: "march", label: "Lopen met rugzak", minimumLabel: "2000 meter met 25 kg, 2000 meter met 35 kg en 800 meter met 45 kg" },
      { id: "swim", label: "Zwemmen", minimumValue: 200, minimumLabel: "200 meter aaneengesloten" },
    ],
    note:
      "De genoemde pagina bevat ook andere deelnamevoorwaarden en onderdelen. Voor deze kennismakingsdagen nemen we geen pull-up- of sit-upminimum over uit een andere eenheid en voegen we geen tijdslimieten toe die hier niet worden vermeld.",
  },
};

export const getOfficialStandardText = (id) => {
  const standard = officialStandards[id];
  return [
    standard.title,
    standard.summary,
    ...standard.requirements.map(
      (requirement) =>
        `${requirement.label}: ${requirement.minimumLabel}.${requirement.protocol ? ` ${requirement.protocol}` : ""}`,
    ),
    standard.note,
    `Bron: ${standard.sourceUrl}. Laatst gecontroleerd: ${standardsVerifiedLabel}.`,
  ].join("\n\n");
};

export const getOfficialRequirementText = (standardId, requirementId) => {
  const standard = officialStandards[standardId];
  const requirement = standard.requirements.find((item) => item.id === requirementId);
  return `${standard.title}: ${requirement.label}: ${requirement.minimumLabel}. Bron: ${standard.sourceUrl}. Laatst gecontroleerd: ${standardsVerifiedLabel}.`;
};
